import { IconButton, IconButtonProps, styled } from "@mui/material";
import { FC, MouseEventHandler, useState } from "react";

import { background, text } from "@/modules/irohana-components/theme/colors";

type TIconBoxProps = {
  size?: number;
  to?: string;
} & Omit<IconButtonProps, "size">;

export const IconBox: FC<TIconBoxProps> = ({ size = 24, onClick, ...rest }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick: MouseEventHandler<HTMLButtonElement> = async (e) => {
    setIsLoading(true);
    await onClick?.(e);
    setIsLoading(false);
  };

  return <IconBoxWrap iconSize={size} onClick={handleClick} disabled={isLoading} tabIndex={-1} {...rest} />;
};

const options = { shouldForwardProp: (propName: string) => !["iconSize"].includes(propName) };

const IconBoxWrap = styled(IconButton, options)<{ iconSize: number }>`
  width: ${({ iconSize }) => iconSize}px;
  height: ${({ iconSize }) => iconSize}px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  cursor: pointer;
  color: ${text.primary};
  svg {
    font-size: ${({ iconSize }) => iconSize}px;
  }
  :hover {
    background-color: ${background.disable};
  }
`;
